<template>
	<v-card class="rounded-lg">
		<div class="small-stat">
			<div class="left">
				<v-icon class="icon" :color="color" size="48">{{
					data.icon
				}}</v-icon>
			</div>
			<div class="right">
				<h1>{{ data.number }}</h1>
				<p>{{ data.name }}</p>
			</div>
		</div>
	</v-card>
</template>

<script>
	export default {
		props: {
			data: Object,
			color: {
				type: String,
				default: "var(--v-accent-base)",
			},
		},
	};
</script>

<style lang="scss" scoped>
	.small-stat {
		overflow: hidden;
		display: flex;
		min-width: 300px;

		.left {
			padding: 1em;
			display: flex;
			align-items: center;
			justify-content: flex-start;
			background-color: var(--v-secondary-base);

			.icon {
			}
		}

		.right {
			padding: 1em;
			flex: 1;

			p {
				text-transform: uppercase;
				margin: 0;
			}
		}
	}
</style>
